import { render, staticRenderFns } from "./ElementsShow.vue?vue&type=template&id=3d3e66b7&"
import script from "./ElementsShow.vue?vue&type=script&lang=js&"
export * from "./ElementsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports